import './ActionButton.scss';

import { PersonRemove } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { setModalConfirmClose, setModalConfirmOpen } from 'domain/modal/store/ModalSlice';
import { StructureProfil } from 'domain/profil/StructureProfil';
import { StructureMember } from 'domain/structureMember/StructureMember';
import { StructureMemberState } from 'domain/structureMember/StructureMemberState';
import { setAllConnectedUserStructures } from 'domain/user/store/UserSlice';
import { stopPropagationBeforeAction } from 'primary/Components/Profils/User/ActionButton/ActionButtonInviteStructure';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useDispatch } from 'react-redux';

interface ActionButtonLeaveStructureProps {
  profil: StructureProfil;
  withIcon?: boolean;
  onLeave?: () => void;
  member?: StructureMember;
}

export const ActionButtonLeaveStructure = ({
  profil,
  withIcon,
  onLeave,
  member,
}: ActionButtonLeaveStructureProps) => {
  const t = useTranslate();
  const { structureMemberRepository, structureRepository, authRepository } =
    useContextDependency();
  const handleClose = () => dispatch(setModalConfirmClose());
  const dispatch = useDispatch();
  const onSubmitted = () => {
    if (!authRepository.currentUser) return;
    handleClose();
    structureRepository
      .getStructuresOfUser(authRepository.currentUser.id)
      .then((structures) => {
        dispatch(setAllConnectedUserStructures(structures));
      });
  };
  const onConfirmDeleteMember = () => {
    structureMemberRepository
      //@ts-ignore
      .deleteMember(authRepository.currentUser?.id, profil?.structure?.id)
      .then(() => {
        onSubmitted();
        onLeave?.();
      });
  };

  const openModalConfirmLeaveStructure = () => {
    if (authRepository?.currentUser) {
      dispatch(
        setModalConfirmOpen({
          props: {
            title: t('profil.userProfilAction.leaveStructureTitle', {
              name: profil.name,
            }),
            labelDecline: t('profil.userProfilAction.leaveStructureBtnCancel'),
            labelAccept: t('profil.userProfilAction.leaveStructureBtnAccept'),
            action: onConfirmDeleteMember,
            description: t('profil.userProfilAction.leaveStructureTextConfirm'),
          },
        }),
      );
    } else {
      authRepository?.login(window.location.href);
    }
  };
  console?.log('MEMBER STATE', member?.state);
  if (!member) return null;
  return (
    <>
      <LoadingButton
        color={'error'}
        variant={'text'}
        className={'-actionButton'}
        onClick={stopPropagationBeforeAction(openModalConfirmLeaveStructure)}
        disabled={!authRepository.currentUser?.id}
      >
        {withIcon && <PersonRemove color={'error'} className={'-error'} />}
        {member?.state === StructureMemberState.ACCEPTED
          ? t('profil.userProfilAction.leaveStructure')
          : member?.state === StructureMemberState.WAITING_JOIN_ACCEPTED
          ? t('profil.userProfilAction.cancelAsk')
          : t('profil.userProfilAction.refuseInvite')}
      </LoadingButton>
    </>
  );
};
